export default __webpack_public_path__ + "static/media/screenshot_app_results_desktop_purple.65866199.png";